<template>
  <div>
    <div v-for="[color, background, fontSize] in classes" :key="color">
      <div>
        <v-btn
        :style="{
          width: width ? width : 'unset',
          height: '38px',
        }"
        :class="[color, background, fontSize]"
        @click="$emit('click')"
        small
        :loading="loading"
        :depressed="depressed"
        :outline="outline"
        >
        <i v-if="icon" :class="icon" aria-hidden="true"></i> {{ label }}
      </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    icon: String,
    depressed: Boolean,
    outline: Boolean,
    search: Boolean,
    advancedSearch: Boolean,
    color: String,
    background: String,
    fontSize: String,
    loading: Boolean,
    width: String,
  },
  data() {
    return {
      label: this.label,
      icon: this.icon,
      depressed: false,
      outline: false,
      loading: this.loading,
      classes: [],
      width: this.width,
    }
  },
  async mounted() {
    // class สี อยู่ที่ file app.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
    let Color
    let Background
    let FontSize

    // class สี อยู่ที่ file app.scss ทั้งหมด ไปเรียกใช้ที่ันั้น
    if (this.depressed) {
      this.depressed = true
      Color = 'color-lightYellow'
      Background = 'background-darkBlue'
    } else if (this.outline) {
      this.outline = true
      Color = 'color-darkBlue'
    } else if (this.search) {
      Background = 'background-gradientYellow none-shadow v-btn-ml'
    } else if (this.advancedSearch) {
      Background = 'color-gradientBlue color-white none-shadow v-btn-ml'
    }

    if (this.color) {
      Color = this.color
    }

    if (this.background) {
      Background = this.background
    }

    if (this.fontSize) {
      FontSize = `fs-${this.fontSize}`
    } else {
      FontSize = 'fs-14'
    }

    this.classes = [[`${Color}`, `${Background}`, `${FontSize}`]]
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Button.vue